module.exports = __webpack_public_path__ + "media/images/emblems/Schupfart-blason-a0bccbd93406fd616d0c3fdad607812d.svg";